import PropTypes from 'prop-types';
import { CloseButton } from '@web/atoms';
import ReactModal from './react-modal';
import {
  GlobalStyle,
  CloseButtonContainer,
  ModalDialog,
  MobileButtonContainer,
  DesktopButtonContainer,
  MobilePopUpGlobalStyle,
  MobilePopUpModalDialog,
} from './styles.js';

export const Modal = ({
  shown,
  ariaLabel,
  onCloseModal,
  children,
  centerModal = false,
  mobileFullScreen = true,
  mobileFullWidthOnly,
  closeBtnColor,
  hideCloseBtnCircle = false,
  mobilePopUp = false,
  popupMobileDialoguePadding = 0,
  usePlumXCloseButton = false,
  dataTestId,
  transparentBackground = false,
}) => {
  return (
    <>
      {!mobilePopUp ? (
        <GlobalStyle
          transparent={transparentBackground}
          centerModal={centerModal}
          mobileFullScreen={mobileFullScreen}
          mobileFullWidthOnly={mobileFullWidthOnly}
        />
      ) : (
        <MobilePopUpGlobalStyle />
      )}
      <ReactModal
        isOpen={shown}
        className={mobileFullScreen ? 'ModalContent--full' : 'ModalContent'}
        overlayClassName={
          mobileFullScreen ? 'ModalOverlay--full' : 'ModalOverlay'
        }
        onRequestClose={onCloseModal}
        contentLabel={ariaLabel}
      >
        <CloseButtonContainer>
          <DesktopButtonContainer>
            <CloseButton
              color={closeBtnColor}
              onClick={onCloseModal}
              usePlumX={usePlumXCloseButton}
              withoutCircle={hideCloseBtnCircle}
            />
          </DesktopButtonContainer>
          <MobileButtonContainer>
            <CloseButton
              color={closeBtnColor}
              onClick={onCloseModal}
              usePlumX={usePlumXCloseButton}
              withoutCircle={hideCloseBtnCircle}
            />
          </MobileButtonContainer>
        </CloseButtonContainer>
        {!mobilePopUp ? (
          <ModalDialog
            centerModal={centerModal}
            mobileFullScreen={mobileFullScreen}
            transparent={transparentBackground}
            data-testid={dataTestId}
          >
            {children}
          </ModalDialog>
        ) : (
          <MobilePopUpModalDialog
            centerModal={centerModal}
            transparent={transparentBackground}
            $popupMobileDialoguePadding={popupMobileDialoguePadding}
            data-testid={dataTestId}
          >
            {children}
          </MobilePopUpModalDialog>
        )}
      </ReactModal>
    </>
  );
};

Modal.displayName = 'Modal';

Modal.propTypes = {
  shown: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  centerModal: PropTypes.bool,
  mobileFullScreen: PropTypes.bool,
  mobileFullWidthOnly: PropTypes.bool,
  closeBtnColor: PropTypes.string,
  mobilePopUp: PropTypes.bool,
  popupMobileDialoguePadding: PropTypes.number,
  usePlumXCloseButton: PropTypes.bool,
  hideCloseBtnCircle: PropTypes.bool,
  transparentBackground: PropTypes.bool,
};
